<template>
  <div class="fit">
    <div class="r-text-intro">שמחים שחזרת!</div>
    <enter-otp
      :onValidOTP="validOTP"
      :onRequiredFieldMissing="missingRequiredField" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Segment from '@/Segment';
import EnterOtp from '@/components/EnterOtp.vue';
import { LOGIN_FIRST_PAGE } from '@/router/consts';

export default {
  name: 'LoginEnterOtp',
  components: { EnterOtp },
  methods: {
    ...mapActions('login', ['memberExists']),
    async validOTP({ saverId, riseupAccountId }) {
      if (saverId) {
        Segment.trackUserInteraction('Saving_FELoginCompleted');
        await this.$router.push({ path: '/meitav/welcome-back' });
      } else if (riseupAccountId) {
        Segment.trackUserInteraction('Saving_FELoginCompleted'); // TODO - should it be a different event?
        await this.$router.push({ path: '/lightup/beginnings' });
      } else {
        Segment.trackUserInteraction('Saving_FELoginSaverDontExist');
        await this.$router.push({ path: '/login/not-a-member' });
      }
    },
    missingRequiredField() {
      this.$router.push(LOGIN_FIRST_PAGE);
    },
  },
};
</script>
